if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super()

        this.quantityInput = this.querySelector('.quantity__input')
        this.limitAlert = this.querySelector('.js-product-limit-alert')

        if (this.quantityInput) {
          this.quantityInput.addEventListener('input', this.onQuantityChange.bind(this))
        }
      }

      onQuantityChange(event) {
        const input = event.target
        const quantity = parseFloat(input.value)
        const maxLimit = parseFloat(input.max) || null

        if (maxLimit !== null && quantity >= maxLimit) {
          input.value = maxLimit
          this.showAlert()
        } else if (isNaN(quantity)) {
          input.value = ''
          this.hideAlert()
        } else {
          this.hideAlert()
        }
      }

      showAlert() {
        if (!this.limitAlert) {
          return
        }
        this.limitAlert.classList.remove('hidden')
        clearTimeout(this.timeoutId)
        this.timeoutId = setTimeout(() => {
          this.limitAlert.classList.add('hidden')
        }, 5000)
      }

      hideAlert() {
        if (!this.limitAlert) {
          return
        }
        this.limitAlert.classList.add('hidden')
      }
    }
  )
}
